var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowstab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8758 16.867H15.5833L16.249 16.2012L15.8244 15.7766L14.4336 17.1672L15.8244 18.5578L16.249 18.1332L15.5833 17.4675H18.4762V7.56738H17.8758V16.867Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.696 7.56738V12.7183L10.0303 12.0524L9.60547 12.4772L10.9963 13.8678L12.3871 12.4772L11.9625 12.0524L11.2966 12.7183V7.56738H10.696Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74885 16.2012L6.41456 16.867H4.12203V7.56738H3.52148V17.4675H6.41456L5.74885 18.1332L6.17346 18.5578L7.56406 17.1672L6.17346 15.7766L5.74885 16.2012Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8312 14.335H8.16602V20.0001H13.8312V14.335Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8312 0.942871H8.16602V6.60803H13.8312V0.942871Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0089 0.942871H15.3438V6.60803H21.0089V0.942871Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65539 0.942871H0.990234V6.60803H6.65539V0.942871Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowstab);
export default __webpack_public_path__ + "static/media/flowstab.57b0934665f7f9868a8ff17124ebdef7.svg";
export { ForwardRef as ReactComponent };